// extracted by mini-css-extract-plugin
module.exports = {"teamWrapper":"teams-module--teamWrapper--JhjNU","teamMembers":"teams-module--teamMembers--3T6o0","name":"teams-module--name--23-Ni","readMore":"teams-module--readMore--HDsFV"};